module.exports = __webpack_public_path__ + "img/订货ico-1.5e9b7a5f.png";